import { FormGroup } from 'react-bootstrap';
import Label from '../../components/Label';
import { showError } from '../../components/Messages';
import Select from '../../components/Select';
import { buildQueryString } from '../../utils/Functions';
import { BaseController } from '../BaseController';
import PerfilDeUsuarioView from './../../views/Neos/PerfilDeUsuarioView';
import TermoDeUsoView from './../../views/Neos/TermoDeUsoView';
import TextArea from '../../components/TextArea';

export default class ParametroDoSistemaController extends BaseController {
   getTitulosDaTabela = () => {
      return [
         { titulo: this.lang.telaDeCadastroDeParametrosDoSistema.descricao, width: '50%', orderby: 'Descricao' },
         { titulo: this.lang.telaDeCadastroDeParametrosDoSistema.valor, width: '50%', orderby: 'Valor' },
      ];
   };

   getDadosDaTabela = (item) => {
      return [item.descricao, this.getDescricaoDoValor(item)];
   };

   getDescricaoDoValor = (item) => {
      var camposObjeto = ['PerfilDeUsuarioParaEmpresa', 'PerfilDeUsuarioParaCliente', 'TermoDeUsoAtivo'];
      var descricao = null;
      if (camposObjeto.filter((i) => i === item.nome).length) {
         if (item.preenchido) {
            descricao = JSON.parse(item.valor);
            descricao = descricao.id + ' - ' + descricao.nome;
         }
      } else {
         descricao =
            item.protegido && item.preenchido ? this.lang.telaDeCadastroDeParametrosDoSistema.protegido : item.valor;
      }
      return descricao;
   };

   getObjetoDeDados = () => {
      return new Promise((resolve, reject) => {
         let item = this.view.state.itemSelecionado;

         if (!item.nome) {
            showError(this.lang.telaDeCadastroDeParametrosDoSistema.mensagens.selecioneOParametro);
            reject();
            return;
         }

         var input = {
            grupo: item.grupo,
            ordem: item.ordem ? item.ordem : 0,
            nome: item.nome,
            descricao: item.descricao,
            valor: item.valor,
            protegido: item.protegido,
         };
         if (this.view.state.alterando) {
            input.id = parseInt(item.id);
         }
         resolve(input);
      });
   };

   comboParametros = () => {
      let comboParametros = this.lang.telaDeCadastroDeParametrosDoSistema.comboParametros;
      let result = [
         // Envio e e-mail
         { nome: 'ServidorSmtp', descricao: comboParametros.servidorSmtp, grupo: 1, ordem: 1 },
         { nome: 'PortaSmtp', descricao: comboParametros.portaSmtp, grupo: 1, ordem: 2 },
         {
            nome: 'UsuarioDoServidorSmtp',
            descricao: comboParametros.usuarioDeAcessoAoServidorSmtp,
            grupo: 1,
            ordem: 3,
            ajuda: comboParametros.usuarioDeAcessoAoServidorSmtp_Ajuda,
         },

         { nome: 'EmailRemetente', descricao: comboParametros.emailRemetente, grupo: 1, ordem: 4 },
         {
            nome: 'SenhaDoServidorSmtp',
            descricao: comboParametros.senhaRemetente,
            grupo: 1,
            ordem: 5,
            protegido: true,
         },
         { nome: 'NomeDoRemetente', descricao: comboParametros.nomeDoRemetente, grupo: 1, ordem: 6 },
         { nome: 'UsarSslNoServidorSmtp', descricao: comboParametros.usarSsl, grupo: 1, ordem: 7 },
         {
            nome: 'PerfilDeUsuarioParaEmpresa',
            descricao: comboParametros.perfilDeUsuarioParaEmpresa,
            grupo: 2,
            ordem: 1,
            componente: (defaultValue, setValor) => {
               defaultValue = defaultValue ? JSON.parse(defaultValue) : null;
               return (
                  <FormGroup>
                     <Label>{comboParametros.selecione}</Label>
                     <Select
                        name={'perfil'}
                        defaultValue={defaultValue}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.nome}
                        onSelect={(i) => {
                           if (i) {
                              setValor(JSON.stringify({ id: i.id, nome: i.nome }));
                           } else {
                              setValor(null);
                           }
                        }}
                        formularioPadrao={(select) => {
                           return (
                              <PerfilDeUsuarioView
                                 api={this.view.props.api}
                                 select={select}
                                 lang={this.view.props.lang}
                                 filtroExtra={() => {
                                    let filtro = {
                                       tipoDePerfil: 2, // Empresa
                                    };
                                    return filtro;
                                 }}
                              />
                           );
                        }}
                        noDropDown={true}
                        readOnlyColor='#ffff'
                        getFilterUrl={(text) =>
                           '/perfildeusuario/fast' +
                           buildQueryString(2, null, 'id', { Searchable: text, tipoDePerfil: 3 })
                        }
                     />
                  </FormGroup>
               );
            },
         },
         {
            nome: 'PerfilDeUsuarioParaCliente',
            descricao: comboParametros.perfilDeUsuarioParaCliente,
            grupo: 2,
            ordem: 1,
            componente: (defaultValue, setValor) => {
               defaultValue = defaultValue ? JSON.parse(defaultValue) : null;
               return (
                  <FormGroup>
                     <Label>{comboParametros.selecione}</Label>
                     <Select
                        name={'perfil'}
                        defaultValue={defaultValue}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.nome}
                        onSelect={(i) => {
                           if (i) {
                              setValor(JSON.stringify({ id: i.id, nome: i.nome }));
                           } else {
                              setValor(null);
                           }
                        }}
                        formularioPadrao={(select) => {
                           return (
                              <PerfilDeUsuarioView
                                 api={this.view.props.api}
                                 select={select}
                                 lang={this.view.props.lang}
                                 filtroExtra={() => {
                                    let filtro = {
                                       tipoDePerfil: 3, // Cliente
                                    };
                                    return filtro;
                                 }}
                              />
                           );
                        }}
                        noDropDown={true}
                        readOnlyColor='#ffff'
                        getFilterUrl={(text) =>
                           '/perfildeusuario/fast' +
                           buildQueryString(2, null, 'id', { Searchable: text, tipoDePerfil: 3 })
                        }
                     />
                  </FormGroup>
               );
            },
         },
         {
            nome: 'TermoDeUsoAtivo',
            descricao: comboParametros.termoDeUsoAtivo,
            grupo: 2,
            ordem: 1,
            componente: (defaultValue, setValor) => {
               defaultValue = defaultValue ? JSON.parse(defaultValue) : null;
               return (
                  <FormGroup>
                     <Label>{comboParametros.selecione}</Label>
                     <Select
                        name={'termoDeUso'}
                        defaultValue={defaultValue}
                        getKeyValue={(i) => i.id}
                        getDescription={(i) => i.nome}
                        onSelect={(i) => {
                           if (i) {
                              setValor(JSON.stringify({ id: i.id, nome: i.nome }));
                           } else {
                              setValor(null);
                           }
                        }}
                        formularioPadrao={(select) => {
                           return (
                              <TermoDeUsoView api={this.view.props.api} select={select} lang={this.view.props.lang} />
                           );
                        }}
                        noDropDown={true}
                        readOnlyColor='#ffff'
                        getFilterUrl={(text) => '/termodeuso' + buildQueryString(2, null, 'id', { Searchable: text })}
                     />
                  </FormGroup>
               );
            },
         },

         { nome: 'UrlPublica', descricao: comboParametros.urlPublica, grupo: 3, ordem: 1 },

         {
            nome: 'TextoParaTesteConforme',
            descricao: comboParametros.textoParaTesteConforme,
            grupo: 3,
            ordem: 1,
            componente: (defaultValue, setValor) => {
               return (
                  <FormGroup>
                     <Label>{comboParametros.informe}</Label>
                     <TextArea
                        defaultValue={defaultValue}
                        onChange={(e) => {
                           setValor(e.target.value);
                        }}
                     />
                  </FormGroup>
               );
            },
         },
         {
            nome: 'TextoParaTesteNaoConforme',
            descricao: comboParametros.textoParaTesteNaoConforme,
            grupo: 3,
            ordem: 1,
            componente: (defaultValue, setValor) => {
               return (
                  <FormGroup>
                     <Label>{comboParametros.informe}</Label>
                     <TextArea
                        defaultValue={defaultValue}
                        onChange={(e) => {
                           setValor(e.target.value);
                        }}
                     />
                  </FormGroup>
               );
            },
         },
         
      ];
      return result;
   };
}
